// extracted by mini-css-extract-plugin
export default {"container":"PaymentFailure_container__t-m4a","heading":"PaymentFailure_heading__9UkzO","message":"PaymentFailure_message__5U363"};